module.exports = __webpack_public_path__ + "static/media/06-make-default.116f1dce.png";